module.exports = __webpack_public_path__ + "static/media/cc_amex.a0926709.svg";